(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-keno.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-keno.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
class RowKeno extends svs.tur.ball.row.Default {
  constructor(_ref) {
    let balls = _ref.balls,
      numbers = _ref.numbers,
      level = _ref.level,
      _ref$kungKeno = _ref.kungKeno,
      kungKeno = _ref$kungKeno === void 0 ? false : _ref$kungKeno,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? false : _ref$description,
      order = _ref.order,
      winPlan = _ref.winPlan,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      showWinInfo = _ref.showWinInfo,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? false : _ref$fill,
      index = _ref.index,
      _ref$addEmptyBall = _ref.addEmptyBall,
      addEmptyBall = _ref$addEmptyBall === void 0 ? true : _ref$addEmptyBall,
      size = _ref.size;
    super({
      balls,
      numbers,
      level,
      kungKeno,
      description,
      order,
      winPlan,
      showWinInfo,
      size,
      BallClass: svs.tur.ball.Keno,
      totalBallAmount: 11,
      index,
      addEmptyBall,
      align
    });
    this.level = level;
    if (fill && this.balls.length < this.totalBallAmount) {
      for (let i = this.balls.length; i < this.totalBallAmount; i++) {
        this.append(new this._BallClass({
          empty: true
        }));
      }
    }
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    super.render(visible);
    if (this.kungKeno && typeof this.kungKeno === 'boolean') {
      this.addKungKenoBall();
    } else if (this.addEmptyBall) {
      this.ballInvisible = new this._BallClass({
        empty: true
      });
      this.$ballsExtra.appendChild(this.ballInvisible.render(false));
    }
    return this.$el;
  }
  addKungKenoBall() {
    this.ballKungKeno = new this._BallClass({
      kungKeno: true
    });
    this.$ballsExtra.appendChild(this.ballKungKeno.render());
    this.kungKeno = true;
  }
  removeKungKenoBall() {
    this.ballKungKeno.delete();
    this.kungKeno = false;
  }
  toggleKungKeno(state) {
    if (state !== this.kungKeno) {
      if (state) {
        this.addKungKenoBall();
      } else if (this.ballKungKeno) {
        this.removeKungKenoBall();
      }
    }
  }
  classNames() {
    return ['ball-row-keno'];
  }
  rollIn() {
    const tl = super.rollIn();
    if (this.kungKeno) {
      tl.fromTo(this.ballKungKeno.render(), 0.3, {
        rotation: -60,
        scale: 0,
        opacity: 0
      }, {
        rotation: 0,
        scale: 1,
        opacity: 1,
        ease: 'elastic.out'
      }, "-=".concat(tl.duration() * 0.5));
    }
    return tl;
  }
  slideIn() {
    const tl = super.slideIn();
    if (this.ballKungKeno) {
      this.ballKungKeno.show();
    }
    return tl;
  }
  clear() {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      removeKungKeno = _ref2.removeKungKeno;
    if (typeof removeKungKeno === 'boolean') {
      if (removeKungKeno && this.kungKeno) {
        this.removeKungKenoBall();
      } else if (!removeKungKeno && !this.kungKeno) {
        this.addKungKenoBall();
      }
    }
    return super.clear();
  }
}
svs.tur.ball.row.Keno = RowKeno;

 })(window);